/**
 * S3 URLから機密性レベルを判定する
 * @param s3Url S3のURL
 * @returns 高機密ファイルかどうか
 */
export const isHighlyConfidentialFile = (s3Url: string): boolean => {
  if (!s3Url || typeof s3Url !== 'string') {
    return false;
  }

  // highly-confidentialバケットかどうかを判定
  return s3Url.includes('highly-confidential');
};

/**
 * 機密ファイルの代替表示用のアイコン
 */
export const CONFIDENTIAL_FILE_ICON = 'EyeOff' as const;
